// extracted by mini-css-extract-plugin
module.exports = {"summary":"MealsSummary_summary__3tFpd"};